import styled, { keyframes } from 'styled-components';
import { black, border1 } from 'utils/style/colors';

export const TASK_CHIP_TRANSITION_CLASS_NAME = 'task-chip';

const fadeOutTaskChip = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
}`;

const fadeInTaskChip = keyframes`
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
}`;

export const TaskFilePickerChip = styled('span')`
  height: 4.5rem;
  width: 15.5rem;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: center;
  flex-wrap: wrap;
  border-radius: 2rem;
  border: ${border1};
  cursor: pointer;
  display: inline-flex;
  font-size: 0.8rem;
  font-weight: 500;
  background: var(--exact-white);
  margin: 0.5rem 0 0.5rem 1rem;
  line-height: 1.2rem;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  transition:
    300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  &.${TASK_CHIP_TRANSITION_CLASS_NAME}-enter {
    animation: ${fadeInTaskChip} 0.3s ease;
  }
  &.${TASK_CHIP_TRANSITION_CLASS_NAME}-exit {
    animation: ${fadeOutTaskChip} 0.3s ease;
  }
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  ::after {
    background-image: radial-gradient(
      circle,
      var(--exact-white) 10%,
      transparent 10.01%
    );
    background-position: 50%;
    background-repeat: no-repeat;
    content: '';
    display: block;
    height: 100%;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    transform: scale(10, 10);
    transition:
      transform 0.5s,
      opacity 1s;
    width: 100%;
  }
  :active {
    ::after {
      opacity: 0.4;
      transform: scale(0, 0);
      transition: 0s;
    }
  }
`;

export const TaskFileType = styled('div')`
  width: 70%;
  ${(props) =>
    `background-image: linear-gradient(to ${props.theme.direction === 'rtl' ? 'left' : 'right'}, ${props.color} 0%, var(--exact-white) 100%);`}
  color: var(--exact-white);
  border-radius: 0 20px 20px 0;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: start;
  padding-inline-start: 1rem;
`;

export const TaskFileContent = styled.div`
  height: 100%;
  width: 100%;
  flex-grow: 1;
  border-radius: 20px;
  background: var(--exact-white);
  padding: 0.8rem 1rem;
  margin-inline-start: ${(props) => (props.editable ? '-2.75rem' : '-3.75rem')};
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: ${black};
  background: rgba(255, 255, 255, 0.5);
  border-inline-start: 1px solid #e0e0e0;
  font-weight: bold;
`;

export const RemoveTaskFileIcon = styled('span')`
  align-self: center;
  justify-self: center;
  text-align: center;
  width: 2.7rem;
  height: 1.5rem;
  padding: 0 0.5rem;
`;

export const LoadingTaskFileIcon = styled('span')`
  width: 1.3rem;
  height: 1.3rem;
  align-self: center;
  margin-inline-end: 0.5rem;
`;

export const TaskFileName = styled('span')`
  color: rgba(0, 0, 0, 0.87);
  display: inline-flex;
  line-height: normal;
  flex: 1;
  font-weight: 400;
  word-break: break-word;
`;
